
import { useState } from "react";
import './ClaimVoucher.scss';
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";

const ClaimVoucher = () => {
  const [giftCode, setGiftCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleGiftCodeChange = (e) => {
    setGiftCode(e.target.value.toUpperCase());
    setError(''); 
    setSuccess(false); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!giftCode.trim()) {
      setError('Please enter a gift card code');
      return;
    }

    if (giftCode.length < 8) {
      setError('Gift card code is too short');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Simulate success/error randomly for demo
      if (Math.random() > 0.3) {
        setSuccess(true);
        setError('');
        // In real app, you would update the balance here
      } else {
        setError('Invalid gift card code. Please check and try again.');
        setSuccess(false);
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  const getContainerClass = () => {
    let baseClass = 'claim-voucher-container';
    if (loading) baseClass += ' loading-state';
    if (success) baseClass += ' success-state';
    if (error) baseClass += ' error-state';
    return baseClass;
  };

  return (
    <>
    <HeaderOne/>

    {/* Breadcrumb */}
    <Breadcrumb />
    
    <div className={getContainerClass()}>
      {/* Page Header */}
      <div className="page-header">
        <h1>Gift Voucher</h1>
        
        <div className="gift-card-info">
          <div className="gift-card-icon">
            <div className="card-visual"></div>
            <div className="card-chip"></div>
          </div>
          
          <div className="gift-card-details">
            <h2 className="card-title">Gift Cards</h2>
            <p className="available-balance">
              Available balance: <span className="balance-amount">₹0.00</span>
            </p>
          </div>
        </div>
      </div>

      {/* Add Gift Card Section */}
      <div className="add-gift-card-section">
        <h2 className="section-title">Add gift card to balance</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="gift-code-input-section">
            <div className="input-wrapper">
              <input
                type="text"
                className="gift-code-input"
                placeholder="Enter gift card code"
                value={giftCode}
                onChange={handleGiftCodeChange}
                disabled={loading}
                maxLength={20}
              />
            </div>
            <p className="code-example">e.g. 8U9S-Y3E8CQ-39MPQ</p>
            {error && <p className="error-message">{error}</p>}
          </div>

          <button 
            type="submit" 
            className="add-gift-card-btn"
            disabled={loading || !giftCode.trim()}
          >
            {loading ? '' : success ? 'Gift Card Added!' : 'Add gift card to balance'}
          </button>
        </form>

        <div className="info-notice">
          <div className="info-icon">i</div>
          <p className="info-text">
            For optimal utilisation, balance expiring the earliest will be redeemed first.
          </p>
        </div>

        <a href="/help" className="help-link">
          Need more help?
        </a>
      </div>
    </div>
    </>
  );
};

export default ClaimVoucher;